import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../../Dashboard/Header";
import axios from "axios";
import {
  Box,
  Grid,
  Paper,
  TextField,
  Switch,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
} from "@mui/material";
import Swal from "sweetalert2";

export default function DetailsVchType() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [voucherDetails, setVoucherDetails] = useState(null);
  const [isVoucherEnabled, setIsVoucherEnabled] = useState(false);
  const [isAmountWise, setIsAmountWise] = useState(false);
  const [approvalLevel, setApprovalLevel] = useState("Primary");
  const userRole = localStorage.getItem("userRole");
  const token = localStorage.getItem("token");
  const cmpid = localStorage.getItem("cmpid");

  // ========================================================

  const fetchVoucherTypes = async (id) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/display/voucherType`,
        { cmpid },
        { headers: { Authorization: token } }
      );
      const voucherstypes = response.data.vchTypeMap[0].vchType;

      const selected = voucherstypes.find((v) => v.vchtypeId === id);
      setVoucherDetails(selected ?? null);

      //  console.log("dssss : ", selected.approvalConfig[0]);
      if (selected.approvalConfig.length > 0) {
        setIsVoucherEnabled(selected.approvalConfig.length > 0);
        setApprovalLevel(selected.approvalConfig[0].level);
        setIsAmountWise(selected.approvalConfig[0].isAmt);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [ModuleStatus, setModuleStatus] = useState([]);

  const ModuleOnOff = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/module/enabledModuleslist",
        { cmpid },
        {
          headers: { Authorization: token },
        }
      );
      const ModuleData = Object.values(response.data);
      //  console.log(ModuleData[0]);
      setModuleStatus(ModuleData[0]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchVoucherTypes(id);
    ModuleOnOff();
  }, [id]);

  const handleSubmit = async () => {
    try {
      const bodydata = [
        {
          TypeName: voucherDetails.vchTypeName,
          type: "voucher",
          level: approvalLevel,
          isAmt: isAmountWise,
          cmpId: cmpid,
          enable: isVoucherEnabled === true ? 1 : 0,
        },
      ];

      // console.log(bodydata);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/approvalModule/insertMasterTypesAppConfig`,
        bodydata,
        { headers: { Authorization: token } }
      );
      // Success Alert
      Swal.fire({
        title: "success!",
        text:
          voucherDetails.vchTypeName +
          ":- Voucher Configuration Submitted Successfully",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#28a745",
        width: "300px",
        padding: "1em",
        customClass: {
          popup: "small-alert",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/Infinite/VoucherType");
        }
      });
    } catch (error) {
      // error alert
      Swal.fire({
        title: "Error!",
        text:
          voucherDetails.vchTypeName +
          ":- Error sending Voucher Configuration!",
        icon: "error",
        confirmButtonText: "Close",
        confirmButtonColor: "red",
        width: "300px",
        padding: "1em",
        customClass: {
          popup: "small-alert",
        },
      });
    }
  };

  if (!voucherDetails) {
    return (
      <Box p={4}>
        <Typography variant="h4" color="error">
          Voucher Not Found
        </Typography>
        <Button variant="contained" sx={{ mt: 2 }} onClick={() => navigate(-1)}>
          ⬅ Go Back
        </Button>
      </Box>
    );
  }

  return (
    <>
      <Box p={{ xs: 2, md: 4 }} mt={8}>
        <Box
          mb={1}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Header
            title="Voucher Details"
            subtitle={`Details for ${voucherDetails.vchTypeName}`}
          />
          <Button variant="outlined" onClick={() => navigate(-1)}>
            ⬅ Back
          </Button>
        </Box>

        <Paper
          elevation={6}
          sx={{ p: 4, borderRadius: 2 }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Name"
                value={voucherDetails.vchTypeName}
                fullWidth
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Parent"
                value={voucherDetails.vchTypeParent}
                fullWidth
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="GST Registration Type"
                value={voucherDetails.vchTypeGSTReg}
                fullWidth
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Created Date"
                value={voucherDetails.createdAt}
                fullWidth
                InputProps={{ readOnly: true }}
              />
            </Grid>
          </Grid>
            {userRole === "admin" && ModuleStatus?.cmp_id === cmpid && ModuleStatus?.status === 1 && (
            <>
              {/* Toggle: Enable Detail Module */}
              <Box mt={3} display="flex" alignItems="center" gap={1}>
                <Typography>Enable Voucher Type</Typography>
                <Switch
                  checked={isVoucherEnabled}
                  onChange={(e) => setIsVoucherEnabled(e.target.checked)}
                  color="success"
                />
              </Box>

              {/* Conditional Extra Fields */}
              {isVoucherEnabled && (
                <Grid container spacing={2} mt={1}>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <InputLabel id="approval-label">
                        Approval Level
                      </InputLabel>
                      <Select
                        labelId="approval-label"
                        value={approvalLevel}
                        label="Approval Level"
                        onChange={(e) => setApprovalLevel(e.target.value)}
                      >
                        <MenuItem value="1">First Level</MenuItem>
                        <MenuItem value="2">Second Level</MenuItem>
                        <MenuItem value="3">Third Level</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Typography>Amount Wise</Typography>
                      <Switch
                        checked={Boolean(isAmountWise)}
                        onChange={(e) => setIsAmountWise(e.target.checked)}
                        color="success"
                      />
                    </Box>
                  </Grid>
                </Grid>
              )}
            </>
          )}

          <Box mt={4} textAlign="right">
            <Button
              variant="contained"
              color="success"
              sx={{ px: 4, py: 1.5 }}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Box>
        </Paper>
      </Box>
    </>
  );
}
